module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-testimonials"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__container"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-testimonials__icon-outer"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__icon-inner"
  }, [_c('Icon', {
    staticClass: "custom-home-testimonials__icon",
    attrs: {
      "name": "smile"
    }
  })], 1)]), _c('swiper', {
    staticClass: "custom-home-testimonials__slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.testimonials), function(slide, i) {
    return _c('swiperSlide', {
      key: i,
      staticClass: "custom-home-testimonials__slide"
    }, [_c('div', {
      staticClass: "custom-home-testimonials__slide-text",
      domProps: {
        "innerHTML": _vm._s(slide.text)
      }
    }), _c('div', {
      staticClass: "custom-home-testimonials__slide-author"
    }, [_vm._v(_vm._s(slide.author))])])
  }), _c('div', {
    staticClass: "custom-home-testimonials__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _c('div', {
    staticClass: "custom-home-testimonials__next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-01"
    }
  })], 1), _c('div', {
    staticClass: "custom-home-testimonials__prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-01"
    }
  })], 1)], 2), (_vm.props.video) ? _c('div', {
    staticClass: "custom-home-testimonials__video-container"
  }, [_c('div', {
    staticClass: "custom-home-testimonials__video-play-btn",
    on: {
      "click": function($event) {
        return _vm.openModal(3)
      }
    }
  }, [_c('Icon', {
    staticClass: "custom-home-testimonials__play-btn-icon",
    attrs: {
      "name": "triangle"
    }
  })], 1), _c('div', {
    staticClass: "custom-home-testimonials__thumb",
    style: ({
      backgroundImage: 'url(' + _vm.props.video_thumb + ')'
    })
  }), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [_c('Video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.video),
      expression: "$store.state.video"
    }],
    attrs: {
      "props": _vm.props.video
    }
  })], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d46d913","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-testimonials/custom-home-testimonials.pug
// module id = 726
// module chunks = 1